/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Envelope140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue}
                d="M37 95c-.276 0-.5.215-.5.49l-.001.644a1.005 1.005 0 00-.365.366h-.644a.5.5 0 00-.482.412L35 97c0 .276.215.5.49.5l.644.001c.088.151.214.277.365.365l.001.644a.5.5 0 00.412.482L37 99c.276 0 .5-.231.5-.505v-.629c.152-.087.278-.214.366-.365l.644-.001a.5.5 0 00.482-.412L39 97c0-.276-.215-.5-.49-.5h-.644a1.005 1.005 0 00-.366-.366v-.642a.5.5 0 00-.412-.484L37 95zm7.75 0a.308.308 0 00-.313.307v.402a.628.628 0 00-.228.228h-.402a.312.312 0 00-.299.243l-.008.07c0 .173.134.313.307.313h.402a.628.628 0 00.228.228v.402c0 .146.107.267.243.299l.07.008a.314.314 0 00.313-.303v-.406a.628.628 0 00.228-.228h.402a.312.312 0 00.299-.243l.008-.07a.308.308 0 00-.307-.313h-.402a.628.628 0 00-.228-.228v-.402a.312.312 0 00-.243-.299L44.75 95zm65 0a.308.308 0 00-.313.307v.402a.628.628 0 00-.228.228h-.402a.312.312 0 00-.299.243l-.008.07c0 .173.134.313.307.313h.402a.628.628 0 00.228.228v.402c0 .146.107.267.243.299l.07.008a.314.314 0 00.313-.303v-.406a.628.628 0 00.228-.228h.402a.312.312 0 00.299-.243l.008-.07a.308.308 0 00-.307-.313h-.402a.628.628 0 00-.228-.228v-.402a.312.312 0 00-.243-.299l-.07-.008zM104 90c-.276 0-.5.215-.5.49l-.001.644a1.005 1.005 0 00-.365.366h-.644a.5.5 0 00-.482.412L102 92c0 .276.215.5.49.5l.644.001c.088.151.214.277.365.365l.001.644a.5.5 0 00.412.482L104 94c.276 0 .5-.231.5-.505v-.629c.152-.087.278-.214.366-.365l.644-.001a.5.5 0 00.482-.412L106 92c0-.276-.215-.5-.49-.5h-.644a1.005 1.005 0 00-.366-.366v-.642a.5.5 0 00-.412-.484L104 90zM29 51c-.276 0-.5.215-.5.49l-.001.644a1.005 1.005 0 00-.365.366h-.644a.5.5 0 00-.482.412L27 53c0 .276.215.5.49.5l.644.001c.088.151.214.277.365.365l.001.644a.5.5 0 00.412.482L29 55c.276 0 .5-.231.5-.505v-.629c.152-.087.278-.214.366-.365l.644-.001a.5.5 0 00.482-.412L31 53c0-.276-.215-.5-.49-.5h-.644a1.005 1.005 0 00-.366-.366v-.642a.5.5 0 00-.412-.484L29 51zm52.75-8a.308.308 0 00-.313.307v.402a.628.628 0 00-.228.228h-.402a.312.312 0 00-.299.243l-.008.07c0 .173.134.313.307.313h.402a.628.628 0 00.228.228v.402c0 .146.107.267.243.299l.07.008a.314.314 0 00.313-.303v-.406a.628.628 0 00.228-.228h.402a.312.312 0 00.299-.243l.008-.07a.308.308 0 00-.307-.312l-.402-.001a.628.628 0 00-.228-.228v-.402a.312.312 0 00-.243-.299L81.75 43zM71 41c-.276 0-.5.215-.5.49l-.001.644a1.005 1.005 0 00-.365.366h-.644a.5.5 0 00-.482.412L69 43c0 .276.215.5.49.5l.644.001c.088.151.214.277.365.365l.001.644a.5.5 0 00.412.482L71 45c.276 0 .5-.231.5-.505v-.629c.152-.087.278-.214.366-.365l.644-.001a.5.5 0 00.482-.412L73 43c0-.276-.215-.5-.49-.5h-.644a1.005 1.005 0 00-.366-.366v-.642a.5.5 0 00-.412-.484L71 41z"
            />
            <g fill={vars.white} stroke={vars.bdlBoxBlue} strokeWidth={2}>
                <path d="M34.831 42.629a1.507 1.507 0 011.739-1.218l64.797 11.426a1.497 1.497 0 011.218 1.738l-7.448 42.237a1.507 1.507 0 01-1.738 1.217L28.6 86.603a1.497 1.497 0 01-1.217-1.738l7.447-42.236z" />
                <path d="M28.16 85.327c-.655.504-.523 1.03.293 1.174l64.168 11.314c.818.144 1.113-.305.666-.995L67.453 56.99a1.358 1.358 0 00-2.001-.343L28.16 85.326z" />
                <path d="M36.479 42.375c-.569-.606-.36-.979.448-.837l64.798 11.426c.816.144.876.565.136.94L66.195 71.95c-.741.376-1.804.187-2.372-.418L36.48 42.375z" />
            </g>
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                d="M62.044 59.16c0-.664.533-1.203 1.192-1.203h37.44c.658 0 1.191.545 1.191 1.203v21.535c0 .665-.533 1.204-1.192 1.204H63.236a1.202 1.202 0 01-1.192-1.204V59.16z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                d="M66.823 63.949c0-.665.533-1.204 1.192-1.204h37.44c.657 0 1.191.545 1.191 1.204v21.535c0 .665-.533 1.203-1.192 1.203h-37.44a1.202 1.202 0 01-1.191-1.203V63.949z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M68.416 81.34c0-.663.536-1.107 1.19-1.024 0 0 1.263.414 11.022.414 6.067 0 8.757 1.235 12.213 1.235 6.99 0 11.065-1.477 11.065-1.477.634-.192 1.147.183 1.147.851v2.554c0 .662-.546 1.198-1.198 1.198h-34.24c-.663 0-1.2-.53-1.2-1.198v-2.554z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M100.224 76.145c.41 0 .75.303.8.7l.006.1c0 .442-.36.8-.806.8h-9.595a.801.801 0 01-.806-.8c0-.442.36-.8.806-.8h9.595zm-2.231-3.2c.406 0 .74.303.79.7l.006.1c0 .442-.363.8-.796.8h-7.374a.796.796 0 01-.796-.8c0-.442.363-.8.796-.8h7.374zm4.036-3.2c.405 0 .739.303.788.7l.006.1a.8.8 0 01-.794.8H90.617a.8.8 0 010-1.6h11.412z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M78.602 82.534a8 8 0 100-16 8 8 0 000 16z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M83.685 80.344a5.996 5.996 0 00-5.083-2.81 5.997 5.997 0 00-5.152 2.923m5.152-5.923a2 2 0 100-4 2 2 0 000 4z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M94.576 48.234l15.378 8.879a1.05 1.05 0 01.326 1.574l-4.793 6.44c-.399.536-1.133.732-1.643.438L90.31 57.752c-.509-.294-.708-1.028-.442-1.642l3.181-7.371a1.05 1.05 0 011.526-.505z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M93.942 50.182c.092-.207.313-.29.518-.172l14.126 8.156a.352.352 0 01.118.52l-2.165 2.945a.456.456 0 01-.58.118L92.662 54.07a.458.458 0 01-.18-.575l1.461-3.314z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M106.264 63.276c.57.33.95.74.847.915l-1.322 2.07c-.117.169-.667.042-1.23-.284L89.596 57.34c-.563-.324-.949-.738-.861-.923l1.131-2.18c.1-.178.644-.055 1.217.276l15.18 8.764z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M101.838 45.235c1.92-.365 6.441 2.254 7.082 4.089.51 1.463-2.636 2.741-3.934 3.2l-3.08 11.922-9.657-5.575 8.784-8.628c-.255-1.353-.726-4.717.805-5.008z"
            />
        </g>
    </AccessibleSVG>
);

export default Envelope140;
